import React, { Component, useEffect, useRef } from "react";
import { connect } from "react-redux";

/*
* REDUCERS AND TYPES
*/
import { ApplicationMode, ApplicationState, ApplicationStateTypes } from "../../lib/store/types/ApplicationStateTypes";
import { ActionStates } from "../../lib/rxMode/ActionStates";
import {
  setAppMode,
  setError,
  clearError,
  setLoadingStatus,
  setLoginStatus,
  setIsBetaWorkstation,
  setShouldRedirect,
} from "../../lib/store/reducers/applicationStateReducer"
import {
  clearRxAssistingOperator, clearRxOperatorInstruction, fetchRxBox, fetchRxSingleItems, getRxAssistingOperator, hideRxComment, pollForRxNextSortBox, pollForRxOrder, setCancelRxSortBox, setPreviousRxInstruction, setRxActionState,
  setRxAssistingOperator,
  setRxBoxModel,
  setRxInputTask,
  setRxMissingAmountDialogSortBoxItem,
  setRxMissingSortBoxItem,
  setRxNormalTransportCart,
  setRxPollForNexSortBoxIntervalID, setRxPollForOrderIntervalID, setRxShowSingleItemList, setRxSingleItems, setRxSingleTransportCart, setRxVerifyOperator, setRxWeightError
} from "../../lib/store/reducers/rxBoxModeReducer";
import { setUser, setWorkstation } from "../../lib/store/reducers/loginInfoReducer";
import { IWorkstationInfoModel, WorkstationInfoModel } from "../../lib/interfaces/Login/IWorkstationInfoModel";
import { IOperatorInfoModel, OperatorInfoModel } from "../../lib/interfaces/Login/IOperatorInfoModel";

/*
* INTERNAL COMPONENT IMPORTS
*/
import Login from "../Login/Login";
import ErrorAlert from "../ErrorAlert/ErrorAlert";
import * as Constants from "./../../utils/Constants";
import { getOperatorMessage } from "../../lib/rxMode/UtilMethods";
import SharedFunctions from "../../utils/SharedFunctions";
import BoxItemList from "../BoxItemList/BoxItemList";
import InfoBar from "../InfoBar/InfoBar";
import InfoFooter from "../InfoFooter/InfoFooter";
import SideBarMenu from "../SideBarMenu/SideBarMenu";
import RxOrderComments from "./RxOrderComments";
import RxOrderWarnings from "./RxOrderWarnings"

/*
* EXTERNAL LIBS 
*/
import { Button, ButtonProps, Dimmer, Grid, Loader, Message } from "semantic-ui-react";

/*
* INTERNAL UTILITY
*/
import * as UtilMethods from "../../utils/UtilMethods";
import { PayloadWrapper } from "../../lib/store/types/PayloadWrapper";
import { IRxBoxAppState, DispatchType, PollForRxOrderType } from "../../lib/rxMode/IRxBoxAppState";
import { ILoginInfo, LoginState, LoginStateTypes } from "../../lib/store/types/LoginStateTypes";
import { LayoutHelperState } from "../../lib/store/types/LayoutHelperState";
import { ActionTypes } from "./../../utils/Constants";
import WorkstationEndpoints from "../../lib/workstation/WorkstationEndpoints";
import { IErrorModel, ErrorModel } from "../../lib/interfaces/Error/IErrorModel";
import { setCompanyID } from "../../lib/store/reducers/cartReducer";
import { IRxAssistantOperator } from "../../lib/rxMode/IRxAssistantOperator";
import SingleItemList from "../SingleItemList/SingleItemList";
import { setRxSingleListButtonHeight } from "../../lib/store/reducers/layoutHelperReducer";
import OperatorEndpoints from "../../lib/operator/OperatorEndpoints";
import { IOperatorInstructionModel } from "../../typewriterModels/IOperatorInstructionModel";
import WarningModal from "../WarningModal/WarningModal";
import { SHOW_WORKSTATION_INSTRUCTION_ERROR_CODE } from "../../utils/constants/errorCodes";
import ArticleWeightModal from "../ArticleWeightModal/ArticleWeightModal";
import SkuEndpoints from "../../lib/sku/SkuEndpoints";
import { LimaOperatorTask } from "../../lib/lima/LimaOperatorTask";
import { IPackCancelledWorkstationType } from "../../lib/ipack/IPackCancelledWorkstationType";
import { checkVersion } from "../../utils/versionCheck/versionCheck";
import MissingSkuModal from "../MissingSkuModal/MissingSkuModal";
import MissingSkuModalSelectMissing from "../MissingSkuModal/MissingSkuModalSelectMissing";
import { ISingleSortBoxItemModel, ISortBoxItemModel } from "../../lib/SortBoxItem/ISortBoxItemModel";
import { ISortBoxModel } from "../../lib/sortbox/ISortBoxModel";

class RXBoxApp extends Component<{
  loginState: LoginState, layout: LayoutHelperState, appState: ApplicationState, rxAppState: IRxBoxAppState,
  setLoginStatus: (status: boolean) => void,
  setUser: (user: IOperatorInfoModel | any) => void,
  setAppMode: (applicationMode: ApplicationMode) => void,
  setWorkstation: (workstationInfo: IWorkstationInfoModel) => void,
  setError: (error: IErrorModel) => void,
  pollForRxOrder: () => PollForRxOrderType,
  setIsBetaWorkstation: (enabled: boolean) => void,
  toggleLoading: (enabled: boolean) => void,
  setRxActionState: (actionState: ActionStates) => void,
  fetchRxBox: (rxOrderSku: number) => void,
  pollForRxNextSortBox: () => void,
  setCompanyID: (companyId: number) => void,
  setCancelRxSortBox: () => void,
  setRxVerifyOperator: (enabled: boolean) => void,
  hideRxComment: (orderCommentIndex: number) => void,
  setRxPollForNexSortBoxIntervalID: (intervalId: NodeJS.Timeout) => void,
  setRxPollForOrderIntervalID: (intervalId: NodeJS.Timeout) => void,
  setRxAssistingOperator: (operator: IRxAssistantOperator) => void,
  clearRxAssistingOperator: (assistingOperatorID: number) => void,
  getRxAssistingOperator: () => void,
  setRxShowSingleItemList: (visiblity: boolean) => void,
  setRxSingleListButtonHeight: (height: number) => void,
  clearError: () => void,
  setPreviousRxInstruction: (instruction: IOperatorInstructionModel) => void,
  setRxWeightError: (error: string) => void,
  setRxInputTask: (operatorTask: LimaOperatorTask) => void,
  setRxSingleTransportCart: (transportCart: string) => void,
  setRxNormalTransportCart: (transportCart: string) => void,
  clearRxOperatorInstruction: () => void,
  setShouldRedirect: (shouldRedirect: boolean) => void,
  setRxMissingSortBoxItem: (sortBoxItem:ISortBoxItemModel|null) => void,
  setRxBoxModel: (sortBoxModel :ISortBoxModel) => void,
  fetchRxSingleItems: ()  => void,
  setRxMissingAmountDialogSortBoxItem: (sortBoxItem:ISortBoxItemModel|null) => void,
}, {}>{
  private _versionCheckInterval: NodeJS.Timeout;

  private _inputRef: React.RefObject<HTMLInputElement>;

  constructor(props: any) {
    super(props);
    this._pollForOrder = this._pollForOrder.bind(this);
    this._pollForNexSortBox = this._pollForNexSortBox.bind(this);
    this._versionCheckInterval = undefined as unknown as NodeJS.Timeout;
    this._inputRef = React.createRef();
  }

  async componentDidUpdate(){
    if (this.props.rxAppState.inputTask !== LimaOperatorTask.undefined) this._inputRef.current?.focus();
  }

  async componentDidMount() {
    this._versionCheckPoll();
    if (this.props.rxAppState.inputTask !== LimaOperatorTask.undefined) this._inputRef.current?.focus();
  }

  componentWillUnmount() {
    if (this.props.rxAppState.pollForOrderIntervalID != undefined) clearInterval(this.props.rxAppState.pollForOrderIntervalID);
    if (this.props.rxAppState.pollForNexSortBoxIntervalID != undefined) clearInterval(this.props.rxAppState.pollForNexSortBoxIntervalID);
    if (this._versionCheckInterval != undefined) clearInterval(this._versionCheckInterval);
  }

  _loginCallback = async (operator: any) => { //TODO operator:ILoginInfo 
    this.props.clearError();
    await this._setWorkstationID();
    this.props.setAppMode(ApplicationMode.RxBoxMode);
    this.props.setUser(new OperatorInfoModel(operator.operatorId, operator.operatorName));
    this.props.setLoginStatus(true);
    this.props.pollForRxOrder();
    this.props.getRxAssistingOperator();
    this.props.setRxPollForOrderIntervalID(setInterval(this._pollForOrder, 5000));
  }
  _addError(error: IErrorModel) {
    this.props.setError({
      message: error.message,
      visible: true,
      errorType: -1,
    });
    this.props.toggleLoading(false);
  }
  async _setWorkstationID() {
    return await new Promise<void>((resolve, reject) => {
      let workstationID = UtilMethods.getParamValue("ws");

      var rejectWrap = (e: IErrorModel) => {
        this._addError(e);
        reject();
      };

      WorkstationEndpoints.getWorkstationInformation(workstationID)
        .then((wsResult: any) => {
          var wsType = wsResult.workstationType;
          let isBetaWorkstation = document.location.href.includes("preprod");
          if (wsType != Constants.WorkstationTypes.RX) {
            this._addError({
              errorType: -1,
              message: "Felaktig arbetsstation!",
              visible: true
            });
            return
          }
          this.props.setWorkstation(new WorkstationInfoModel(workstationID,
            wsType,
            wsResult.branchID,
            wsResult.autoScaleEnabled));
          this.props.setIsBetaWorkstation(isBetaWorkstation);
          this.props.setCompanyID(Constants.PackagingTypes.Apotea);
          return resolve();
        })
        .catch(rejectWrap);
    });
  }

  _pollForOrder = async () => {
    const { rxModeAction, rxOrderSku, crateID, pollForNexSortBoxIntervalID } = this.props.rxAppState;
    const { loggedIn, shouldRedirect } = this.props.appState;
    console.log(loggedIn);
    console.log(rxModeAction);
    if (loggedIn) {
      if (rxModeAction === ActionStates.SCAN_SHELF_OR_CART ||
        rxModeAction === ActionStates.SCAN_SINGLE_ARTICLE ||
        rxModeAction === ActionStates.SET_CART) {
        if (shouldRedirect) {
          this.props.setShouldRedirect(false);
          this.props.setLoginStatus(false);
        } else {
          this.props.pollForRxOrder();
          if (pollForNexSortBoxIntervalID == undefined &&
            (rxModeAction === ActionStates.SCAN_SHELF_OR_CART || rxModeAction === ActionStates.SCAN_SINGLE_ARTICLE))
            this.props.setRxPollForNexSortBoxIntervalID(setInterval(this._pollForNexSortBox, 15000));
        }
      } else if (rxModeAction === ActionStates.COMPLETE_BOX && crateID != -1) {
        this.props.fetchRxBox(rxOrderSku);
        if (pollForNexSortBoxIntervalID != undefined) {
          clearInterval(pollForNexSortBoxIntervalID);
          this.props.setRxPollForNexSortBoxIntervalID(undefined as unknown as NodeJS.Timeout)
        }
      }

    }
  }
  _onInputKeyPress(e: React.KeyboardEvent<HTMLInputElement>) {
    if (e.key !== "Enter") {
      return;
    }
    let targetRef = e.target as HTMLInputElement;
    let input = targetRef.value.trim().toUpperCase();
    const { inputTask, singleTransportCart, normalTransportCart } = this.props.rxAppState;
    if (input == singleTransportCart || input == normalTransportCart) {
      this._addError({
        errorType: -1,
        message: "Angiven transportback är redan registrerad.",
        visible: true
      });
    } else if (input.length != 7 || input.substring(0, 1) !== "H") {
      this._addError({
        errorType: -1,
        message: "Det scannade värdet är inte en giltig transportback.",
        visible: true
      });
    } else {
      if (inputTask === LimaOperatorTask.RegisterNormalTransportCart) {
        this.props.setRxNormalTransportCart(input);
      } else if (inputTask === LimaOperatorTask.RegisterSingleTransportCart) {
        this.props.setRxSingleTransportCart(input);
      }
    }

    this.props.setRxInputTask(LimaOperatorTask.undefined);
    targetRef.value = "";
  }

  _updateBoxItemsState(skuID: number) {
    const { sortBoxModel } = this.props.rxAppState;
    var updateBoxitems = sortBoxModel?.sortBoxItems;
    updateBoxitems?.forEach((bi) => {
      if (bi.skuID === skuID) {
        bi.requireWeighing = false;
      }
    });
  }


  _versionCheckPoll = () => {
    this._versionCheckInterval = setInterval(
      () =>
        checkVersion((shoudRedirect: boolean) => {
          if (shoudRedirect !== this.props.appState.shouldRedirect) {
            this.props.setShouldRedirect(shoudRedirect);
          }
        }),
      20000
    );
  };


  _setWeightError(message: string) {
    this.props.setRxWeightError(message);
  }
  _setWeightOnSku(skuID: number | null | undefined, weight: number | null | undefined, ref: any) {
    if (skuID && weight) {
      return SkuEndpoints.setWeightOnSku(skuID, weight).then((result: boolean) => {
        if (result == true) {
          this._setWeightError('');
          this._updateBoxItemsState(skuID);
        } else {
          this._setWeightError('Felaktig vikt angiven');
        }
      });
    }
  }

  _measurementCallback = (skuID: number | null | undefined) => {
    if (skuID && skuID !== -1) {
      this._updateBoxItemsState(skuID);
    }
  }
  _pollForNexSortBox = async () => {
    this.props.pollForRxNextSortBox();
  }

  hideInstruction(_: String, intruction: IOperatorInstructionModel) {
    if (intruction.desiredTask != LimaOperatorTask.RegisterNormalTransportCart && intruction.desiredTask != LimaOperatorTask.RegisterSingleTransportCart &&
      intruction.desiredTask != LimaOperatorTask.CheckRxSubsidy)
      this.props.setPreviousRxInstruction(intruction);
    else this.props.clearRxOperatorInstruction();
  }

  _skuIsMissing(skuID:number, shelfNumber:string, sortBoxItem:ISortBoxItemModel | null) {
    var boxItem : ISortBoxItemModel
    const { sortBoxModel,rxSortBox} = this.props.rxAppState;
    if (sortBoxItem) {
      boxItem = sortBoxItem;
    } else {
      boxItem = SharedFunctions.mergeItems("skuID", sortBoxModel?.sortBoxItems).find(
        (bi: { skuID: number; shelfNumber: string; }) => bi.skuID === skuID && bi.shelfNumber === shelfNumber
      );
    }
    if (boxItem.reservedQuantity > 1 && rxSortBox === boxItem.boxID){
      this.props.setRxMissingAmountDialogSortBoxItem(boxItem);
    } else this.props.setRxMissingSortBoxItem(boxItem);
  }

  render() {
    if (!this.props.loginState.operatorID || this.props.loginState.operatorID === -1) {
      if (this.props.rxAppState.pollForOrderIntervalID != undefined) {
        clearInterval(this.props.rxAppState.pollForOrderIntervalID);
        this.props.setRxPollForOrderIntervalID(undefined as unknown as NodeJS.Timeout)
      }
      if (this.props.rxAppState.pollForNexSortBoxIntervalID != undefined) {
        clearInterval(this.props.rxAppState.pollForNexSortBoxIntervalID);
        this.props.setRxPollForNexSortBoxIntervalID(undefined as unknown as NodeJS.Timeout)
      }
      return (
        <React.Fragment>
          <Login
            loginCallback={(operator: ILoginInfo) => this._loginCallback(operator)}
            workstationID={UtilMethods.getParamValue("ws")}
            loginView={Constants.VIEW.RX}
          />
          <ErrorAlert error={""} />
        </React.Fragment>
      );
    }

    const { loading } = this.props.appState;
    const { sortBoxModel, rxModeAction, orderComments, crateID, currentInstruction, orderNumber, sortID,
      rxSortBox, nextCartShelf, fullCartNumber, verifyOperator, assistingOperators: assistingOperators,
      warningMessages, showSingleItemList, singleItemList, previousInstruction, rxOrderSku, weightError, inputTask, singleTransportCart,
      normalTransportCart, missingSortBoxItem, missingAmountDialogSortBoxItem } = this.props.rxAppState;
    const { operatorName, operatorID, autoScaleEnabled } = this.props.loginState;
    let boxItems = sortBoxModel === null ? [] : sortBoxModel.sortBoxItems;
    boxItems = SharedFunctions.mergeItems("skuID", boxItems);
    const { height, rxWarningHeight, rxSingleItemListButtonHeight } = this.props.layout;

    return (
      <div className={""}>
        <Dimmer active={loading} inverted>
          <Loader size="big" />
        </Dimmer>
        <SideBarMenu logOut={() => this.props.setLoginStatus(false)} ></SideBarMenu>
        <Grid columns={2} className="GridContainer">
          <Grid.Column className="articleColumn" width={12}>
            <BoxItemList
              boxItems={boxItems}
              isLoading={loading}
              skuIsMissingCallback={(skuID:number, shelfNumber:string, sortBoxItem:ISortBoxItemModel)=>{this._skuIsMissing(skuID, shelfNumber,sortBoxItem);}}
              skuInputCallback={undefined} isSingle={undefined} isWaitingForBox={undefined}
              aframe={undefined} skuChannels={undefined} isPaused={undefined} isAuto={undefined} isUrgent={undefined}
              showProgress={false}
              isRxMode={true}
              currentRXSortBoxID={sortBoxModel?.sortBoxID}
            ></BoxItemList>
          </Grid.Column>
          <Grid.Column className="flexColumn" width={4}>
            <InfoBar
              fromReview={false}
              latestShipping={null}
              noPackMessage={false}
              allVerified={false}
              currentCart={crateID}
              isAuto={false}
              nextAction={ActionTypes.SCAN_ARTICLE}
              shelfCallback={() => this.props.setCancelRxSortBox()}
              cancelSortBoxAccess={false}
              showCancelButton={sortBoxModel?.forceNormalWorkstation == 0 && rxModeAction === ActionStates.COMPLETE_BOX}
              waitingForDeliveryRequest={false}
              waitingForNewIPackBox={false}
              operatorInstruction={getOperatorMessage(rxModeAction, sortBoxModel, nextCartShelf)}
              operator={operatorName}
              operatorID={operatorID}
              isPartialDelivery={false}
              wasCancelled={sortBoxModel && sortBoxModel.forceNormalWorkstation == IPackCancelledWorkstationType.Manual && rxModeAction === ActionStates.COMPLETE_BOX}
              cartContent={null}
              currentOrderNumber={orderNumber}
              currentSortBoxID={rxSortBox}
              currentShelf={sortBoxModel?.shelfNumber} 
              cartType={null}
              shippingMethod={null}
              weight={0}
              scannedWeight={null}
              fromAFrameControl={false}
              sortID={sortID}
              aFrameCompletionMode={false}
              isPaused={true} 
              isSingle={false} 
              sortType={sortBoxModel?.sortType}
              workstationType={this.props.loginState.workstationType}
              sortWorkstationType={null
              } 
              isScanIdValidationCancelSortboxRequired={
                this.props.appState.isScanIdValidationCancelSortboxRequired
              }
              aFrameControlStation={false}
              rxMode={true}
              verifyOperatorExternal={verifyOperator}
              setVerifyOperatorCallback={this.props.setRxVerifyOperator}
              nextCartShelf={nextCartShelf}
              rxAssistantOperators={assistingOperators}
              cancelAssistantOperatorCallback={this.props.clearRxAssistingOperator}
              setAssistantOperatorCallback={this.props.setRxAssistingOperator}
              shippingHasIDCheck={sortBoxModel?.shippingMethodHasIDCheck}
              rxOrderSku={rxOrderSku}
              rxCheckSubsidy={sortBoxModel && sortBoxModel.forceNormalWorkstation == IPackCancelledWorkstationType.Paused}
            ></InfoBar>
            <RxOrderWarnings warningMessages={warningMessages} ></RxOrderWarnings>
            {!showSingleItemList && (sortBoxModel?.sortType == 1 || singleItemList.length > 0) ? (
              <div ref={(el) => {
                let currentHeight = el?.clientHeight;
                if (currentHeight != null && rxSingleItemListButtonHeight != currentHeight) this.props.setRxSingleListButtonHeight(currentHeight);
              }}>
                <Button
                  style={{ width: "100%" }}
                  color="grey"
                  visible="false"
                  onClick={(event: React.MouseEvent<HTMLButtonElement>, data: ButtonProps) => this.props.setRxShowSingleItemList(true)}>
                  VISA INNEHÅLL I SINGELFACK
                </Button>
              </div>) : null}
            {showSingleItemList ? (
              <div ref={(el) => {
                let currentHeight = el?.clientHeight;
                if (currentHeight != null && rxSingleItemListButtonHeight != currentHeight) this.props.setRxSingleListButtonHeight(currentHeight);
              }}>
                <Button
                  style={{ width: "100%" }}
                  color="yellow"
                  visible="false"
                  onClick={(event: React.MouseEvent<HTMLButtonElement>, data: ButtonProps) => this.props.setRxShowSingleItemList(false)}>
                  VISA ORDERKOMMENTARER
                </Button>
              </div>) : null}
            {showSingleItemList || rxModeAction == ActionStates.SCAN_SINGLE_ARTICLE ? (<SingleItemList
              infoBarHeight={height + rxSingleItemListButtonHeight + rxWarningHeight}
              crateId={crateID}
              boxItems={singleItemList}
              cartItems={null}
              getNextSortBoxCallback={null}
              skuIsMissingCallback={(skuID:number, shelfNumber:string, sortBoxItem:ISortBoxItemModel)=>{this._skuIsMissing(skuID, shelfNumber,sortBoxItem);}}
              isLoading={loading}
              currentSortBoxID={rxSortBox}
              refreshCallback={() => {
                this.props.toggleLoading(true);
                this.props.pollForRxNextSortBox();
              }}
              manualSkuCallback={null} 
              missingCallback={(skuID:number, shelfNumber:string, sortBoxItem:ISortBoxItemModel)=>{this._skuIsMissing(skuID, shelfNumber,sortBoxItem);}} 
              showRxCommentsCallback={() => this.props.setRxShowSingleItemList(false)}
              rxMode={true}
            />) : null}
            {!showSingleItemList ? (<RxOrderComments orderComments={orderComments}
              hideCommentCallback={this.props.hideRxComment}
              infoBarHeight={(sortBoxModel?.sortType == 1) ? height + rxSingleItemListButtonHeight + rxWarningHeight : height + rxWarningHeight}></RxOrderComments>) : null}
          </Grid.Column>
        </Grid>
        {!!missingSortBoxItem ? (
          <MissingSkuModal
            open={!!missingSortBoxItem}
            fromReview={false}
            removeSkuAccess={false}
            currentOrderNumber={orderNumber}
            boxItem={missingSortBoxItem}
            foundSkuCallback={(newSortBoxItems:ISortBoxItemModel[])=>{
              if (rxSortBox === newSortBoxItems[0].boxID){
                newSortBoxItems = SharedFunctions.getUpdatedBoxItems(newSortBoxItems, sortBoxModel?.sortBoxItems)
                const newSortBoxModel = { ...sortBoxModel, sortBoxItems: newSortBoxItems };
                this.props.setRxBoxModel(newSortBoxModel as ISortBoxModel);
              }else{
                this.props.fetchRxSingleItems();
              }
            }} 
            onClose={()=>{this.props.setRxMissingSortBoxItem(null);}}
            cartNumber={null}
            isScanIdValidationRemoveSkuRequired={
              this.props.appState.isScanIdValidationRemoveSkuRequired
            }
            partialDelivery={false}
            loginState={this.props.loginState}
          />
        ) : null}
        {!!missingAmountDialogSortBoxItem ? (
          <MissingSkuModalSelectMissing onCloseClearState={() => {
            this.props.setRxMissingAmountDialogSortBoxItem(null);
          } }
          boxItem={missingAmountDialogSortBoxItem} missingSkuSetVerifiedQuantity={(missingAmount: number | null, boxItem: ISortBoxItemModel) => {
            const { sortBoxModel, rxSortBox } = this.props.rxAppState;
            if (!missingAmount || rxSortBox != boxItem.boxID)
              return;
            boxItem.verifiedQuantity = boxItem.reservedQuantity - missingAmount;
            this.props.setRxMissingAmountDialogSortBoxItem(null);
            this.props.setRxMissingSortBoxItem(boxItem);
          } } reservedQuantityIsMaxMissing={false} />
        ) : null}
        {currentInstruction &&
          (previousInstruction?.id != currentInstruction.id || previousInstruction?.desiredCartId != currentInstruction.desiredCartId ||
            previousInstruction?.desiredSortId != currentInstruction.desiredSortId ||
            previousInstruction?.desiredWorkstationId != currentInstruction.desiredWorkstationId ||
            previousInstruction?.desiredTask != currentInstruction.desiredTask) ? (
          <WarningModal
            open={true}
            onClose={(actionKey: String) => { this.hideInstruction(actionKey, currentInstruction); }}
            message={currentInstruction?.message}
            header={"Hänvisning"}
            cssClass={"warning-modal-instruction"}
            autoClose={false}
            isCartInstruction={false} //this.state.isCartInstruction
            workstationID={this.props.loginState.workstationID}
            cartSuggestion={null} //this.props.cartState.cartSuggestion
            changeCartSuggestion={null}
            acceptCart={null}
            closeButtonText={"OK"}
            errorCode={SHOW_WORKSTATION_INSTRUCTION_ERROR_CODE}
          />
        ) : null}
        <ErrorAlert error={this.props.appState.errorMessage} />
        <ArticleWeightModal
          scannedSKU={sortBoxModel?.sortBoxItems?.find(z => z.requireWeighing)?.skuID ?? -1}
          boxItems={sortBoxModel?.sortBoxItems}
          getWeight={(skuID: number | null | undefined) => (skuID) ? SkuEndpoints.getWeightSku(skuID) : null}
          setWeight={(skuID: number | null | undefined, weight: number | null | undefined) => { return this._setWeightOnSku(skuID, weight, this) }}
          autoScaleEnabled={autoScaleEnabled}
          cartShelfID={sortBoxModel?.shelfNumber?.toString() ?? ""}
          callback={this._measurementCallback}
          weightError={weightError} />
        <InfoFooter
          operatorName={operatorName}
          isApoteaPackaging={true}
          sortID={sortID}
          cartID={fullCartNumber}
          orderNumber={(rxModeAction === ActionStates.COMPLETE_BOX) ? orderNumber : null}
          cartShelf={undefined} workstationID={undefined}
          companyID={undefined} pendingInstruction={undefined}
          boxID={undefined} cartLocationHistory={undefined}
          singleTransportCart={(singleTransportCart) ? singleTransportCart : ""}
          normalTransportCart={(normalTransportCart) ? normalTransportCart : ""}
        />
        <input
          placeholder={((inputTask === LimaOperatorTask.RegisterSingleTransportCart) ? "Singeltransportback" : (inputTask === LimaOperatorTask.RegisterNormalTransportCart) ? "Normal transportback" : "")}
          className="ScanInputField"
          autoComplete="off"
          id="ScanInputField"
          autoFocus
          onKeyDown={(e) => this._onInputKeyPress(e)}
          ref={this._inputRef}
          disabled={(inputTask !== LimaOperatorTask.RegisterSingleTransportCart && inputTask !== LimaOperatorTask.RegisterNormalTransportCart)}
        />
      </div>
    );
  }
}

const mapStateToProps = (state: any) => {
  return {
    loginState: state.loginInfoReducer as LoginState,
    layout: state.layoutHelperReducer as LayoutHelperState,
    appState: state.applicationStateReducer as ApplicationState,
    rxAppState: state.rxModeReducer as IRxBoxAppState,
  };
};


const mapDispatchToProps = (dispatch: DispatchType) => {
  return {
    setAppMode: (mode: ApplicationMode) => dispatch(setAppMode(new PayloadWrapper(mode))),
    toggleLoading: (loading: boolean) => dispatch(setLoadingStatus(new PayloadWrapper(loading))),
    clearError: () => dispatch(clearError()),
    setWorkstation: (workstationInfo: IWorkstationInfoModel) =>
      dispatch(setWorkstation(workstationInfo)),
    setUser: (user: IOperatorInfoModel) =>
      dispatch(setUser(user)),
    setError: (error: IErrorModel) => dispatch(setError(error)),
    pollForRxOrder: () => dispatch(pollForRxOrder()),
    setLoginStatus: (status: boolean) =>
      dispatch(setLoginStatus(new PayloadWrapper(status))),
    fetchRxBox: (rxOrderSku: number) => dispatch(fetchRxBox(new PayloadWrapper(rxOrderSku))),
    setIsBetaWorkstation: (beta: boolean) => dispatch(setIsBetaWorkstation(new PayloadWrapper(beta))),
    setRxActionState: (actionState: ActionStates) => dispatch(setRxActionState(new PayloadWrapper(actionState))),
    pollForRxNextSortBox: () => dispatch(pollForRxNextSortBox()),
    setCompanyID: (companyID: number) => dispatch(setCompanyID(new PayloadWrapper(companyID))),
    setCancelRxSortBox: () => dispatch(setCancelRxSortBox()),
    setRxVerifyOperator: (enabled: boolean) => dispatch(setRxVerifyOperator(new PayloadWrapper(enabled))),
    hideRxComment: (orderCommentIndex: number) => dispatch(hideRxComment(new PayloadWrapper(orderCommentIndex))),
    setRxPollForNexSortBoxIntervalID: (intervalId: NodeJS.Timeout) => dispatch(setRxPollForNexSortBoxIntervalID(new PayloadWrapper(intervalId))),
    setRxPollForOrderIntervalID: (intervalId: NodeJS.Timeout) => dispatch(setRxPollForOrderIntervalID(new PayloadWrapper(intervalId))),
    setRxAssistingOperator: (operator: IRxAssistantOperator) => dispatch(setRxAssistingOperator(operator)),
    clearRxAssistingOperator: (assistingOperatorID: number) => dispatch(clearRxAssistingOperator(new PayloadWrapper(assistingOperatorID))),
    getRxAssistingOperator: () => dispatch(getRxAssistingOperator()),
    setRxShowSingleItemList: (visiblity: boolean) => dispatch(setRxShowSingleItemList(new PayloadWrapper(visiblity))),
    setRxSingleListButtonHeight: (height: number) => dispatch(setRxSingleListButtonHeight(new PayloadWrapper(height))),
    setPreviousRxInstruction: (instruction: IOperatorInstructionModel) => dispatch(setPreviousRxInstruction(instruction)),
    setRxWeightError: (error: string) => dispatch(setRxWeightError(new PayloadWrapper(error))),
    setRxInputTask: (operatorTask: LimaOperatorTask) => dispatch(setRxInputTask(new PayloadWrapper(operatorTask))),
    setRxSingleTransportCart: (transportCart: string) => dispatch(setRxSingleTransportCart(new PayloadWrapper(transportCart))),
    setRxNormalTransportCart: (transportCart: string) => dispatch(setRxNormalTransportCart(new PayloadWrapper(transportCart))),
    clearRxOperatorInstruction: () => dispatch(clearRxOperatorInstruction()),
    setShouldRedirect: (shouldRedirect: boolean) => dispatch(setShouldRedirect(new PayloadWrapper(shouldRedirect))),
    setRxMissingSortBoxItem: (sortBoxItem:ISortBoxItemModel|null) => dispatch(setRxMissingSortBoxItem(new PayloadWrapper(sortBoxItem))),
    setRxBoxModel: (sortBoxModel :ISortBoxModel) => dispatch(setRxBoxModel(new PayloadWrapper(sortBoxModel))),
    fetchRxSingleItems: ()  => dispatch(fetchRxSingleItems()), 
    setRxMissingAmountDialogSortBoxItem: (sortBoxItem:ISortBoxItemModel|null) => dispatch(setRxMissingAmountDialogSortBoxItem(new PayloadWrapper(sortBoxItem))),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(RXBoxApp);

